import auth0Client from "src/Auth";

// Hook for determining the trial status of a free user
export const useTrialStatus = () => {
  const profile = auth0Client.getProfile();

  if (!profile) {
    return { isTrialUser: false, isTrialExpired: false, daysRemaining: null };
  }

  const isTrialExpired: boolean = profile.trialExpired ?? false;
  const daysRemaining: number | null = profile.trialRemaining ?? null;

  const isTrialUser = daysRemaining !== null || isTrialExpired === true;

  return { isTrialUser, isTrialExpired, daysRemaining };
};
